import { createSelector } from 'reselect'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'

const DISABLE_KEY = 'disable_service_fee'

export const getDefaultDepositAmountPercentage = createSelector(
  (state: App.State) => state.system.depositConfigs,
  (state: App.State) => getOptimizelyExperimentVariation(state, OptimizelyExperiments.paymentsDepositOptionForHotelsAbove1999V2),
  (depositConfigs, depositVariation): number => {
    if (!depositConfigs) return 0
    if (depositVariation) {
      return depositConfigs.ABOVE_1999_DEPOSIT_PERCENTAGE_OVERRIDE
    }
    return depositConfigs.DEPOSIT_AMOUNT_PERCENTAGE
  },
)

export const getDepositServiceFee = createSelector(
  (state: App.State) => state.system.depositConfigs,
  (state: App.State) => getOptimizelyExperimentVariation(state, OptimizelyExperiments.paymentsDepositOptionForHotelsAbove1999V2),
  (depositConfigs, depositVariation): number => {
    if (!depositConfigs) return 0
    if (depositVariation) {
      return depositConfigs.ABOVE_1999_SERVICE_FEE_PERCENTAGE_OVERRIDE
    }
    return depositConfigs.SERVICE_FEE_PERCENTAGE
  },
)

export const getDepositServiceFeeConfig = createSelector(
  (state: App.State) => getDepositServiceFee(state),
  (state: App.State) => state.system.originalCanonicalURL,
  (state: App.State) => state.offer.tourV2Offers,
  (state: App.State) => state.system.depositConfigs,
  (depositServiceFee, url = ''): App.Checkout.ServiceFeeSettings => {
    const queryString = url.slice(url.indexOf('?') + 1)
    const params = new URLSearchParams(queryString)
    const isEnabled = params.get(DISABLE_KEY) !== 'true'

    return {
      isEnabled: isEnabled && (Number(depositServiceFee) !== 0),
      percentage: depositServiceFee,
    }
  },
)
